// extracted by mini-css-extract-plugin
module.exports = {"header":"_1FZDbpeu6cE9_11Qtox7lv","message":"_2p7Rh63UczYoto0u_peHNS","advertiserDisclosure":"_37Z6z-5Gb6F91Hcdm-MXK0"};